var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 36.375C19.75 36.375 19.5207 36.3333 19.312 36.25C19.104 36.1667 18.9027 36.0277 18.708 35.833L8.95799 26.083C8.59733 25.7223 8.41699 25.285 8.41699 24.771C8.41699 24.257 8.59733 23.8193 8.95799 23.458C9.31933 23.0973 9.74999 22.917 10.25 22.917C10.75 22.917 11.1807 23.0973 11.542 23.458L18.167 30.125V4.50001C18.167 4.00001 18.3407 3.57634 18.688 3.22901C19.0347 2.88167 19.472 2.70801 20 2.70801C20.528 2.70801 20.9653 2.88167 21.312 3.22901C21.6593 3.57634 21.833 4.01401 21.833 4.54201V30.125L28.5 23.458C28.8333 23.1247 29.25 22.9513 29.75 22.938C30.25 22.924 30.6807 23.0973 31.042 23.458C31.4027 23.8193 31.583 24.257 31.583 24.771C31.583 25.285 31.4027 25.7223 31.042 26.083L21.292 35.833C21.0973 36.0277 20.896 36.1667 20.688 36.25C20.4793 36.3333 20.25 36.375 20 36.375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.306cd628c3a224ffbe7a8cb1c8cf517a.svg";
export { ForwardRef as ReactComponent };